/**
 * Executes a function a max of once every n milliseconds
 */
export function throttle(callback: (args: IArguments) => void, delay: number) {
	let wait = false

	return function () {
		if (!wait) {
			// eslint-disable-next-line prefer-spread, prefer-rest-params
			callback.apply(null, arguments)
			wait = true

			setTimeout(function () {
				wait = false
			}, delay)
		}
	}
}
